"use client";
import MenuItem from "./menu/MenuItem";
import TopWinnerSpecial from "./TopWinnerSpecial";
import {
  ICompanySubMenu,
  MenuItemType,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import { Nav } from "react-bootstrap";
import { IsTopWinner } from "@/utils/functions/global-constants";
import MenuLink from "./menu/MenuLink";
import { Fragment, useState } from "react";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import useIsClient from "@/hooks/useIsClient";

interface Props {
  isMobile?: boolean;
}
const maxTopLevel = 5; // Maximum items for top-level menu
const maxSubMenu = 20; // Maximum items for sub-menus

function rec(
  array: ICompanySubMenu[],
  more: string,
  maxTopLevel: number,
  maxSubMenu: number,
) {
  // Handle top-level array length
  if (
    array.length > maxTopLevel + 3 &&
    array[maxTopLevel]?.type !== MenuItemType.more
  ) {
    const slicedArray = array.slice(0, maxTopLevel);
    const moreSubMenu = array.slice(maxTopLevel);
    slicedArray.push({
      value: "more",
      type: MenuItemType.more,
      title: more,
      sub_menu: rec(moreSubMenu, more, maxSubMenu, maxSubMenu), // Recursively process the more sub-menu with sub-menu rules
    });
    array = slicedArray;
  }

  // Process sub-menus recursively
  for (let i in array) {
    if (
      array[i] &&
      array[i].sub_menu &&
      Array.isArray(array[i].sub_menu) &&
      array[i].sub_menu.length > maxSubMenu + 3 &&
      array[i].sub_menu[maxSubMenu].type !== MenuItemType.more
    ) {
      const subMenu = array[i].sub_menu.slice();
      array[i] = { ...array[i], sub_menu: subMenu.slice(0, maxSubMenu) };
      array[i].sub_menu.push({
        value: "more",
        type: MenuItemType.more,
        title: more,
        sub_menu: rec(subMenu.slice(maxSubMenu), more, maxSubMenu, maxSubMenu), // Recursively process the more sub-menu
      });
    }
    if (array[i] && array[i].sub_menu) {
      array[i].sub_menu = rec(array[i].sub_menu, more, maxSubMenu, maxSubMenu);
    }
  }
  return array;
}
const useArraySlicer = (array: []) => {
  const [isSliced, setIsSliced] = useState(true);
  const arraySlicer = (
    length: number,
    showMore: string,
    showLess: string,
  ): any[] => {
    if (array.length > length) {
      if (isSliced) {
        const showMoreObj: ICompanySubMenu & { onClick: () => void } = {
          title: showMore,
          onClick: () => setIsSliced(false),
          value: "",
          sub_menu: [],
          type: MenuItemType.more,
        };
        const newArray = [...array.slice(0, length), , showMoreObj];
        return newArray;
      } else {
        const showLessObj: ICompanySubMenu & { onClick: () => void } = {
          title: showLess,
          onClick: () => setIsSliced(true),
          value: "",
          sub_menu: [],
          type: MenuItemType.more,
        };
        const newArray = [...array, showLessObj];
        return newArray;
      }
    }
    return array;
  };

  return arraySlicer;
};

const CompanyMenus: React.FC<Props> = ({ isMobile = false }) => {
  const t = useTranslation();
  const isClient = useIsClient();
  const getCompany = useGetCompanyQuery();
  const { menu } = getCompany?.data?.result ?? {};
  const arraySlicer = useArraySlicer(((menu || [])?.[0]?.sub_menu as []) || []);
  if (!menu || menu?.length === 0) return null;
  let pcMenu: ICompanySubMenu[] = [];
  if (!isMobile)
    pcMenu = addParentId(rec(menu, t.more, maxTopLevel, maxSubMenu));
  const mobileMenu = addParentId([
    {
      ...menu[0],
      sub_menu: arraySlicer(10, t.MoreCategories, t.LessCategories),
    },
    ...menu.slice(1),
  ]);
  if (!isClient) {
    return <></>;
  }
  return (
    <Nav className="nav w-100 ">
      {IsTopWinner(getCompany.data?.result!) && (
        <MenuLink isMobile={isMobile} href={"/"} title={{ text: t.home }} />
      )}

      {(isMobile ? mobileMenu : pcMenu)?.map((everyMenu, key, array) => (
        <Fragment key={key}>
          <MenuItem
            key={key}
            item={everyMenu as ICompanySubMenu}
            isMobile={isMobile}
            down
            dropdown={key === 0 ? false : true}
            toggle={everyMenu.sub_menu.length > 0 && key > 0}
            title={
              isMobile && (everyMenu.sub_menu.length < 1 || key === 0)
                ? false
                : everyMenu.title
            }
          />
          {isMobile && (key === 0 || key === array.length - 1) && (
            <hr className="m-0 h-0" />
          )}
        </Fragment>
      ))}
      {IsTopWinner(getCompany.data?.result!) && (
        <TopWinnerSpecial isMobile={isMobile} />
      )}
    </Nav>
  );
};
export default CompanyMenus;

function addParentId(
  arr: ICompanySubMenu[],
  parentId: string | null = null,
): ICompanySubMenu[] {
  return arr.map((item) => ({
    ...item,
    parentId,
    ...(item.sub_menu
      ? { sub_menu: addParentId(item.sub_menu, item.value) }
      : {}),
  }));
}
